import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

// TODO: Fix this and use the design system's Text component - @Ari
export const Heading = styled.h1<{
	hasMargin?: boolean;
	color?: 'gray7' | 'white';
	centerAboveMobile?: boolean;
}>`
	${fontSize(FontSizes.xl)};
	color: ${p => palette(p.color || 'gray7')};
	${fontWeight(FontWeights.Regular)};
	margin-bottom: ${(props): string => (props.hasMargin ? '40px' : '8px')};
	margin-top: 16px;

	${minWidth('tablet')} {
		margin-top: 0;
		${p => (p.centerAboveMobile ? 'text-align: center;' : '')}
	}
`;
